module.exports = __webpack_public_path__ + "static/media/IMAGE-3-GREEN-BEANS-desktop.dcdceac9.jpg";